let examplePills, examplePanes;

function selectPill(event) {
    examplePills.forEach((pill) => {
      pill.classList.remove('active');
    });
    examplePanes.forEach((pane) => {
      pane.classList.remove('selected');
    });
    event.target.classList.add('active');
    const selectedPane = document.getElementById(event.target.dataset.blockId);
    selectedPane.classList.add('selected');
  }

document.addEventListener('DOMContentLoaded', () => {
    const hash = window.location.hash; // Get the URL fragment (e.g., #section1)
    if (hash) {
      const targetElement = document.querySelector(hash); // Find the element
      if (targetElement) {
        // Add the highlight class
        targetElement.classList.add('highlight');
        targetElement.scrollIntoView(
            { behavior: 'smooth', block: 'center' }
        ); // Scroll to the element
        
        // Optionally, remove the highlight after some time
        setTimeout(() => {
          targetElement.classList.remove('highlight');
        }, 3000); // Remove highlight after 3 seconds
      }
    }
    examplePills = document.querySelectorAll('.projects-block .pill');
    examplePanes = document.querySelectorAll('.projects-block .project');
    examplePills.forEach((pill) => {
      pill.addEventListener('click', selectPill);
      pill.addEventListener('keyup', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          selectPill(e);
        }
      });
    });
  });
